import { useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';

interface RouteChangeTrackerProps {
  facebookPixel: {
    pageView: () => void;
    track: (event: string, data?: object) => void;
    trackCustom: (event: string, data?: object) => void;
  };
}

const RouteChangeTracker = ({ facebookPixel }: RouteChangeTrackerProps) => {
  const { location } = useRouterState();

  useEffect(() => {
    facebookPixel.pageView();
  }, [facebookPixel, location.pathname]);

  return null;
};

export default RouteChangeTracker;
